module.exports = __webpack_public_path__ + "img/m_contents_hospital@2x.74912e93.png";